import React from 'react';

/**
 * LegalFooter. All legal copy is supplied by the owner — the slots render
 * as dashed placeholders until replaced in the CMS. `extended` (ads variant)
 * adds the extra disclaimer slots.
 */
export default function LegalFooter({ footer = {}, extended = false }) {
  const brandLabel = process.env.REACT_APP_BRAND_LABEL || footer.brand_label || '';
  const supportEmail = process.env.REACT_APP_SUPPORT_EMAIL || footer.support_email || '';
  const privacyUrl = process.env.REACT_APP_PRIVACY_URL || (footer.privacy_url?.startsWith('[') ? '#' : footer.privacy_url) || '#';
  const termsUrl = process.env.REACT_APP_TERMS_URL || (footer.terms_url?.startsWith('[') ? '#' : footer.terms_url) || '#';
  const slots = [...(footer.legal_slots || []), ...(extended ? footer.ads_variant_extra_slots || [] : [])];

  return (
    <footer data-testid="legal-footer">
      <div className="wrap narrow">
        {slots.map((s, i) => <p className="slot" key={i}>{s}</p>)}
        <p className="links">
          <a href={privacyUrl} target="_blank" rel="noopener noreferrer">Privacy Policy</a> ·{' '}
          <a href={termsUrl} target="_blank" rel="noopener noreferrer">Terms &amp; Conditions</a> ·{' '}
          <a href={`mailto:${supportEmail}`}>{supportEmail}</a>
        </p>
        <p className="copy-r">
          © {new Date().getFullYear()} {footer.legal_name} · {brandLabel}
          {footer.parent_label ? ` · ${footer.parent_label}` : ''}. All rights reserved.
        </p>
      </div>
    </footer>
  );
}
